export default function generateWatchProjectImage(url: string | undefined | null, referenceNumber: string): string {
  if (!url) {
    return `https://valoracion.cdbarcelona.com/img/watch/${referenceNumber}.jpg`;
  }

  if (url.includes('http')) {
    return url;
  }

  const path = url.startsWith('/') ? url.slice(1) : url;
  const uploadPath = path.includes('upload') ? path : `upload/${path}`;
  return `${process.env.GATSBY_API_BASE_URL}/${uploadPath}`;
}
